import { useUserStore } from '@Auth/store';
import { useListingPagesStore } from '@pages/User/store/listingPages.store';
import { queryClient } from '@utils/queryClient';

export const clearLocalSession = () => {
  useUserStore.getState().clearUser();
  useListingPagesStore.getState().clearSessionState();
  queryClient.clear();
};
